/**
 * The ownership-mismatch sentence, shared by the connect refusal (`errors.tsx`,
 * from `Ga4OwnershipError.details`) and the pre-connect check (`ConnectForm.tsx`,
 * from `checkGa4Streams`): the same words either way a mismatch is discovered.
 */
export function ownershipMismatchMessage(streamHosts: readonly string[], websiteHosts: readonly string[]): string {
  const streams = streamHosts.length ? streamHosts.join(', ') : 'none'
  const sites = websiteHosts.length ? websiteHosts.join(', ') : 'none'
  return `None of this property's web data streams (${streams}) matches one of your websites (${sites}). Add the missing host as a website, or connect a property whose data stream is one of them.`
}
